import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { PONCTUEL_PROGRAMMED } from '../services/rachat-allocation';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
  selector: 'rachat-partiel-type-form',
  templateUrl: './rachat-partiel-type-form.component.html',
  styleUrls: ['./rachat-partiel-type-form.component.scss'],
  standalone: false,
})
export class RachatPartielTypeFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options: FormControlOption[] = [
    {
      label: 'Rachat partiel ponctuel',
      value: 'PONCTUEL',
      suffix: 'A',
    },
    {
      label: 'Rachat ponctuel + rachats programmés',
      value: PONCTUEL_PROGRAMMED,
      suffix: 'B',
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
